import type { Env } from '@bucketplace/config';
import { datadogRum } from '@datadog/browser-rum';

interface InitDatadogRumParam {
  applicationId: string;
  clientToken: string;
  service: string;
  env: Env;
  version?: string;
  sessionSampleRate: number;
  sessionReplaySampleRate: number;
}

export function initDatadogRum({
  applicationId,
  clientToken,
  service,
  env,
  version = '',
  sessionSampleRate,
  sessionReplaySampleRate,
}: InitDatadogRumParam): void {
  if (typeof window === 'undefined' || !['qa', 'prod'].includes(env ?? '')) {
    return;
  }

  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service,
    env: env === 'prod' ? 'production' : env,
    version,
    sessionSampleRate,
    sessionReplaySampleRate,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
  });

  if (sessionReplaySampleRate > 0) {
    datadogRum.startSessionReplayRecording();
  }
}
